import { chakra } from '@chakra-ui/react';
import { Combobox } from '@ark-ui/react/combobox';

export const FibosearchCombobox = {
  Root: chakra(Combobox.Root, {
    base: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '1',
    },
  }),
  Control: chakra(Combobox.Control),
  Input: chakra(Combobox.Input, {}, { forwardAsChild: true }),
  Content: chakra(Combobox.Content, {
    base: {
      maxHeight: '500px',
      overflowY: 'auto',
      borderRadius: '4px',
      zIndex: 'docked',
    },
  }),
  Positioner: chakra(Combobox.Positioner),
  List: chakra(Combobox.List),
  ItemGroup: chakra(Combobox.ItemGroup, {
    base: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '20px',
    },
  }),
  ItemGroupLabel: chakra(Combobox.ItemGroupLabel, {
    base: {
      pointerEvents: 'none',
      userSelect: 'none',
      paddingX: '8px',
    },
  }),
  ItemText: chakra(Combobox.ItemText),
  Item: chakra(Combobox.Item, {
    base: {
      textStyle: 'body3',
      color: 'neutral.80',
      width: '100%',
      padding: '6px 8px',
      _hover: {
        backgroundColor: 'neutral.10/40',
        color: 'neutral.100',
        textDecoration: 'underline',
        cursor: 'pointer',
      },
      _selected: {
        backgroundColor: 'neutral.10/40',
        '& > p:first-of-type': {
          color: 'neutral.100',
          textDecoration: 'underline',
        },
      },
    },
  }),
};
